<template>

  <div :class="[popupmodalActive ? 'open' : '', theme == 'white' ?'text-dark' : 'text-white']" class="w-100 popupmodal position-fixed p-3">
    <div :class="[theme == 'dark' ? 'bg-fourth-'+theme : 'bg-specialbackground-'+theme]" class="w-100 position-relative popupmodal__inner d-flex align-items-center justify-content-center">
      <svg class="erroricon" clip-rule="evenodd" fill-rule="evenodd" height="32" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 254000 254000" width="32" xmlns="http://www.w3.org/2000/svg">
        <g id="图层_x0020_1">
          <path d="m127000 0c70129 0 127000 56871 127000 127000s-56871 127000-127000 127000-127000-56871-127000-127000 56871-127000 127000-127000zm-64190 172969 45969-45969-45969-45969c-2637-2638-2637-6941 0-9578l8643-8643c2637-2637 6940-2637 9578 0l45969 45969 45969-45969c2638-2637 6941-2637 9578 0l8643 8643c2637 2637 2637 6940 0 9578l-45969 45969 45969 45969c2637 2638 2637 6941 0 9578l-8643 8643c-2637 2637-6940 2637-9578 0l-45969-45969-45969 45969c-2638 2637-6941 2637-9578 0l-8643-8643c-2637-2637-2637-6940 0-9578z" :fill="[theme == 'dark' ? '#FDC300' : '#c80000']"/>
        </g>
      </svg>
      <p class="pl-5"><span v-html="popupMessage">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</span></p>
      <div class="close" @click="closePopup">
        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" class=""><g id="_02_User" data-name="02 User"><path :fill="[theme == 'dark' ? '#FFF' : '#000']" d="m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z"></path> <path :fill="[theme == 'dark' ? '#FFF' : '#000']" d="m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z"></path></g></svg>
      </div>
    </div>
  </div>
</template>

<script>
import {eventBus} from 'fire-vue-core';

export default {
  name: 'toastmessage',
  data: () => (
      {
        popupmodalActive: false,
        popupMessage : '',
      }
  ),
  directives: {},
  mixins: [],
  props: {
    theme: String,
    directMessage: String,
  },
  watch: {},
  created()
  {
    if (this.directMessage)
    {
      this.popupMessage = this.directMessage;
      this.popupmodalActive= true;
    }
  },
  destroyed()
  {

  },
  mounted()
  {
    eventBus.$on('OpenPopup', (message) =>
        {
          this.popupMessage = message;
          this.popupmodalActive= true;
        }
    )
    eventBus.$on('ClosePopup', () =>
    {
      this.popupmodalActive = false
    })
  },
  methods: {
    closePopup()
    {
      this.popupmodalActive = false;
    }
  }
};
</script>

<style lang="scss">
@import "frontend/styles/framework";
.popupmodal {
  .close {
    position: absolute;
    top: 15px;
    right: 15px;
    //margin: 15px;
    cursor: pointer;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .erroricon {
    min-width: 32px;
    min-height: 32px;
  }
}
.popupmodal {
  z-index: 99999;
  top: 50%;
  max-width: 656px;
  left: 50%;
  transform: translate(-50%,-50%);
  opacity: 0;
  visibility: hidden;
  transition: all 1s;
  &__inner{
    padding: 9%;
    p{
      font-size: 1.05rem;
      font-weight: 300;
      ul{
        li{
          font-size: 0.9rem;
        }
      }
    }
  }
  &.open {
    opacity: 1;
    visibility: visible;
  }
  @media (min-width: 400px) {
    &__inner{
      p{
        font-size: 1.35rem;
      }
    }
  }
}
</style>